import {Link} from 'external/react'
import {
   clsx
  ,styled
  ,Box
  ,FormControlLabel
  ,Checkbox
} from 'external/material'

import {ArrowLeftIcon, ArrowRightIcon} from 'resources/icons'

import {centerVertically} from 'utils/style'
import useTranslations from 'hooks/translations'
import useSession from 'hooks/session'
import useAssessment from 'hooks/assessment'

//import FinalizeAssessment from '../FinalizeAssessment'

const NavigationContainer = styled(Box)(navigationStyles)
 
export default function Navigation ({sections, openFinalize}) {

  const {translate} = useTranslations()
  const {questionId, sectionId, assessmentId, navigation} = useSession()
  const {assessment, assessmentLoaded, save} = useAssessment()

  const link = (sectionId, questionId) => questionId
      ? navigation.assessmentQuestion.link({sectionId, questionId})
      : navigation.assessmentSection.link({sectionId})

  const sectionIndex = sections.findIndex(s => s.id == sectionId)
  const section = sectionIndex >= 0 && sections[sectionIndex]

  const questionIndex = questionId && section ? section.questions.findIndex(q => q.id == questionId) : -1

  const question = questionIndex >= 0 && section.questions[questionIndex]

  const isFirst = !questionId && sectionIndex == 0

  const isLastSection = sectionIndex == sections.length - 1
  const isLastQuestion = section && questionIndex == section.questions.length - 1

  const isLast = isLastSection && isLastQuestion

  async function handleFinalize() {
    openFinalize(true)
  }

  const nextTo = () => {

    if (!section) return '#'

    if (questionId)
      return isLastQuestion
        ? link(sections[sectionIndex + 1].id)
        : link(sectionId, section.questions[questionIndex + 1].id)

    return link(sectionId, section.questions[0].id)

  }

  const previousTo = () => {
    if (!section) return '#'
    if (questionId) {
      return questionIndex > 0 && section.questions[questionIndex - 1]
        ? link(sectionId, section.questions[questionIndex - 1].id)
        : link(sectionId)
    }

    const previousSection = sections[sectionIndex - 1]
    const lastQuestion = previousSection.questions[previousSection.questions.length - 1]
    if (lastQuestion) return link(previousSection.id, lastQuestion.id)
    return '#'
  }

  const {answers = {}} = assessment || {}
  const answer = answers[questionId]
  const marked = answer ? answer.pending == true : false

  async function handleMark (e) {
    const pending = e.target.checked
    const command = answer
      ? {[questionId]: {pending: {$set: pending}}}
      : {$apply: answers => ({...answers, [questionId]: {pending}})}
    save(command)
  }


  return (<>
    <NavigationContainer className="root">
      {questionId && (
        <FormControlLabel
          size="small"
          className="pendingReview"
          control={(
            <Checkbox
              size="small"
              color="primary"
              checked={marked} 
              onChange={handleMark}
            />)
          }
          label={translate('pending-review') || ''}
        />
      )}
      <Box className="filler" />
      <Box className="buttons" >
        {!isFirst && (
          <NavigationButton name="previous" to={previousTo()}>
              <Box className="buttonIcon"><ArrowLeftIcon width={16} fill="#6278f0"/></Box>
              <Box className={clsx("buttonLabel", "previous")}>{translate('previous')}</Box>
          </NavigationButton>
        )}
        {!isLast && (
          <NavigationButton name="next" to={nextTo()}>
            <Box className={clsx("buttonLabel", "next")}>{translate('next')}</Box>
            <Box className="buttonIcon"><ArrowRightIcon width={16} fill="#6278f0"/></Box>
          </NavigationButton>
        )}
        {isLast && (
          <NavigationButton onClick={openFinalize} name="finalize">
            <Box className={clsx("buttonLabel", "finalize")}>{translate('finalize')}</Box>
          </NavigationButton>
        )}
      </Box>
    </NavigationContainer>
  </>
  )
}

function NavigationButton (props) {
  const {name, onClick, to} = props
  const Elem = to ? Link : Box
  return ( 
    <Elem to={to} onClick={onClick} className={clsx("button", name)}>
      {props.children}
    </Elem>
  )
}

function navigationStyles() {
  return {
    "&.root": {
      display: 'flex',
      "& .filler" : {
        flexGrow: 1
      }
    },
    "& .pendingReview": {
      color: '#4c4f58'
    },
    "& .buttons": {
      display: 'flex'
    },
    "& .button" : {
      cursor: 'pointer',
      display: 'flex',
      padding: '5px',
      fontSize: '12pt',
      backgroundColor: '#f0f0f0',
      color: '#6278f0',
      borderRadius: 3,
      width: 110,
      textDecoration: 'none',
      "&:last-child": {
        marginLeft: 20
      },
    },
    "& .buttonLabel": {
      flexGrow: 1,
      ...centerVertically,
      textAlign: 'center',
    },
    "& .buttonIcon": {
      ...centerVertically
    }
  }
}
